"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
function prepareSearchPhrase(text) {
    return text.toLowerCase().replace(/[ćšđčž]/g, function (m) {
        return {
            'ć': 'c',
            'š': 's',
            'đ': 'dj',
            'č': 'c',
            'ž': 'z',
        }[m];
    });
}
CurrencyService.$inject = ['storage', 'api', '$q'];
function CurrencyService(storage, api, $q) {
    var _currency = storage.getItem('currency'); //true - din, false - eur
    var _currencyValue = 1;
    var _eurValue = 1;
    var _init = false;
    var service = {};
    service.get = function () {
        if (_currency === null) {
            service.set(true);
            return true;
        }
        return _currency;
    };
    service.getValue = function () {
        if (_currency) {
            return $q.when(_currencyValue);
        }
        else {
            return initGet().then(function () {
                return _eurValue;
            });
        }
    };
    service.set = function (val) {
        _currency = val;
        storage.setItem('currency', val);
    };
    var initGet = function () {
        if (!_init) {
            _init = api.get('/b2b/settings/currency_value').then(function (response) {
                _eurValue = response;
                return _eurValue;
            });
        }
        return $q.when(_init);
    };
    return service;
}
SwitchCurrencyDirective.$inject = ['$rootScope', '_currency'];
function SwitchCurrencyDirective($rootScope, _currency) {
    return {
        link: function (scope, element, items) {
            $rootScope.currency = _currency.get();
            $rootScope.currency_value = 1;
            $rootScope.$watch('currency', function (nval, oval) {
                if (nval !== oval) {
                    _currency.set(nval);
                }
                _currency.getValue().then(function (value) {
                    $rootScope.currency_value = value;
                });
            });
        }
    };
}
SwitchVatDirective.$inject = ['$rootScope', 'storage'];
function SwitchVatDirective($rootScope, storage) {
    return {
        link: function (scope, element, items) {
            var _vat = storage.getItem('vat');
            if (_vat !== null) {
                $rootScope.show_vat = _vat;
            }
            else {
                $rootScope.show_vat = false;
            }
            $rootScope.$watch('show_vat', function (nval, oval) {
                if (nval !== oval) {
                    storage.setItem('vat', nval);
                }
            });
        }
    };
}
exports.SwitchVatDirective = SwitchVatDirective;
SwitchPricesDirective.$inject = ['$rootScope', 'storage'];
function SwitchPricesDirective($rootScope, storage) {
    return {
        link: function (scope, element, items) {
            var _prices = storage.getItem('showprices');
            if (_prices !== null) {
                $rootScope.show_prices = _prices;
            }
            else {
                $rootScope.show_prices = true;
            }
            $rootScope.$watch('show_prices', function (nval, oval) {
                if (nval !== oval) {
                    storage.setItem('showprices', nval);
                }
            });
        }
    };
}
exports.SwitchPricesDirective = SwitchPricesDirective;
CategoriesService.$inject = ['storage', 'api', '$q'];
function CategoriesService(storage, api, $q) {
    var _categories = null;
    var _init = false;
    var service = {};
    service.get = function () {
        if (_categories) {
            return $q.when(_categories);
        }
        else {
            return initGet().then(function () {
                return _categories;
            });
        }
    };
    service.set = function (data) {
        _categories = data;
    };
    var initGet = function () {
        if (!_init) {
            _init = api.get('/b2b/categories/list').then(function (response) {
                service.set(response);
                return _categories;
            });
        }
        return $q.when(_init);
    };
    return service;
}
MenuToolbarDirective.$inject = ['$state', 'auth', '$document', 'api', '$rootScope', 'storage', '_categories', '_analytics'];
function MenuToolbarDirective($state, auth, $document, api, $rootScope, storage, _categories, _analytics) {
    return {
        template: require('./views/menu-toolbar.html'),
        link: function (scope, attrs, elem) {
            scope.$state = $state;
            scope.currentUser = $rootScope;
            scope.logout = function () {
                auth.setToken(null);
            };
            scope.categoriesMenu = {
                isopen: false,
                searchText: null
            };
            scope.toggleCategories = function (open) {
                if (!open) {
                    scope.categoriesMenu.searchText = null; //reset search on close
                }
            };
            scope.search = function () {
                if (!scope.categories.plain) {
                    return [];
                }
                if (!scope.categoriesMenu.searchText) {
                    return;
                }
                var results = [];
                var searchWord = prepareSearchPhrase(scope.categoriesMenu.searchText);
                lodash_1.default.each(scope.categories.plain, function (category) {
                    var found = false;
                    if (category.name_search.indexOf(searchWord) >= 0) {
                        found = true;
                    }
                    else {
                        if (category.keywords) {
                            var keywords = category.keywords.split(',');
                            lodash_1.default.each(keywords, function (k) {
                                if (k.indexOf(searchWord) >= 0) {
                                    found = true;
                                    return;
                                }
                            });
                        }
                    }
                    if (found) {
                        results.push(category);
                    }
                });
                return results;
            };
            scope.categories = [];
            _categories.get().then(function (response) {
                scope.categories = {
                    plain: lodash_1.default.map(response.plain, function (c) {
                        c.name_search = prepareSearchPhrase(c.name);
                        return c;
                    }),
                    tree: response.tree,
                };
            });
            if (!$rootScope.cart_total) {
                api.get('/b2b/cart/total').then(function (response) {
                    $rootScope.cart_total = response.total;
                    $rootScope.cart_total_vat = response.total_vat;
                    $rootScope.cart_size = response.cart_size;
                }, function (error) {
                    scope.errors = error.data;
                    $rootScope.cart_total = 0;
                    $rootScope.cart_size = 0;
                });
            }
            scope.show_menu = false;
            var side_cart_open = storage.getItem('side_cart');
            if (side_cart_open !== null) {
                scope.side_cart_open = side_cart_open;
                scope.$broadcast('sideCartToggle', { isOpen: scope.side_cart_open });
            }
            else {
                scope.side_cart_open = false;
                storage.setItem('side_cart', false);
                scope.$broadcast('sideCartToggle', { isOpen: scope.side_cart_open });
            }
            scope.toggleMenu = function () {
                scope.show_menu = !scope.show_menu;
                scope.$broadcast('closeProductModal');
            };
            scope.goToCart = function () {
                scope.$broadcast('closeProductModal');
            };
            scope.toggleSideCart = function () {
                scope.side_cart_open = !scope.side_cart_open;
                storage.setItem('side_cart', scope.side_cart_open);
                scope.$broadcast('sideCartToggle', { isOpen: scope.side_cart_open });
            };
            scope.$on('$locationChangeSuccess', function ($event, next, current) {
                _analytics.pageView();
            });
        }
    };
}
CategorySearchDirective.$inject = [];
function CategorySearchDirective() {
    return {
        require: '^uibDropdown',
        link: function (scope, element, attrs, dropdownCtrl) {
            scope.$watch(dropdownCtrl.isOpen, function (isOpen, wasOpen) {
                if (!wasOpen && isOpen) {
                    lodash_1.default.defer(function () {
                        $(element).focus();
                    }, 0);
                }
                ;
            });
        }
    };
}
angular.module('rinca.core.directives.menu-toolbar', ['rinca.core.storage'])
    .directive('menuToolbar', MenuToolbarDirective)
    .service('_currency', CurrencyService)
    .service('_categories', CategoriesService)
    .directive('switchVat', SwitchVatDirective)
    .directive('switchCurrency', SwitchCurrencyDirective)
    .directive('switchPrices', SwitchPricesDirective)
    .directive('categorySearch', CategorySearchDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/MenuToolbarDirective.ts
// module id = 298
// module chunks = 0